export const CLEAR_EXAMPLES = 'examples/CLEAR_EXAMPLES';
export const GET_EXAMPLES = 'examples/GET_EXAMPLES';



// WEBPACK FOOTER //
// ./src/redux/Examples/constants.js